import { AssingCompaniesDto, FormAdministratorDto, RowFormHierarchyDto, RowAdministratorDto, CreateAdministratorDto, UpdateAdministratorDto, AdministratorExportDto } from "@/dtos";
import { Administrator, Contact, Identification } from "@/entities";
import { ContactType, getAdministratorIdentificationType } from "@/helpers/types";
import { getIdentification } from "@/helpers/options";

export const formatTableAdministratorDto = async (administrators: Administrator[]): Promise<RowAdministratorDto[]> => {
    return administrators.map((x) => {
        const isConfigCorrectly =  x.administratorApplications.length > 0 && x.administratorApplications.some(y => y.administrator_application_services.length > 0);

        const row: RowAdministratorDto = {
            ...x,
            ceo_label: (x.is_ceo) ? 'CEO' : 'No es CEO',
            identification_type: getIdentification(x.identification?.type)?.label,
            dni: x.identification?.identification ?? '',
            email: x.contact?.find((x) => x.type == ContactType.EMAIL)?.identification ?? '',
            cellphone: x.contact?.find((x) => x.type == ContactType.CELLPHONE)?.identification ?? '',
            is_config_label: isConfigCorrectly ? 'Completa' : 'Incompleta',
            active: x.is_active ? 'Activo' : 'Inactivo',
        }
        return row;
    });
}

export const getIdenficationDto = (formAdministrator: FormAdministratorDto) => {
    const identification: Identification = {
        countryId: formAdministrator.country_id,
        type: getAdministratorIdentificationType(formAdministrator.type_identification),
        identification: formAdministrator.identification,
        isValidate: false
    }

    return identification;
}

export const getContacts = (formAdministrator: FormAdministratorDto) => {
    const contacts: Contact[] = [];
    if (formAdministrator.email) {
        const email: Contact = {
            type: ContactType.EMAIL,
            identification: formAdministrator.email,
            alias: "Correo Electrónico",
            isValidate: false
        }
        contacts.push(email);
    }

    if (formAdministrator.cellphone) {
        const cellphone: Contact = {
            type: ContactType.CELLPHONE,
            identification: formAdministrator.cellphone,
            country_code: formAdministrator.country_code,
            abbreviation: formAdministrator.abbreviation,
            alias: "Número Telefónico",
            isValidate: false
        }
        contacts.push(cellphone);
    }

    return contacts;
}

export const formatAdministratorDto = async (formAdministrator: FormAdministratorDto, isCreate: boolean) => {
    const administratorDto = {
        first_name: formAdministrator.first_name,
        last_name: formAdministrator.last_name,
        identification: getIdenficationDto(formAdministrator),
        contact: getContacts(formAdministrator),
        birth_date: formAdministrator.birthdate,
        is_ceo: formAdministrator.is_ceo,
        enable_system_access: formAdministrator.enable_system_access,
        user_name: formAdministrator.user_name,
        detail: formAdministrator.details,
        password_hash: undefined,
        system_id: 1,
        color: formAdministrator.color
    }

    return (isCreate) ? administratorDto as CreateAdministratorDto : administratorDto as UpdateAdministratorDto;
}

export const formatAssingCompaniesDto = (rows: RowFormHierarchyDto[], admin_id: number, admin_id_assing: number): AssingCompaniesDto[] => {
    const result: AssingCompaniesDto[] = [];
    for (const row of rows) {
        const idCompany = parseInt(row.code.split('-')[0]);
        const idRole = parseInt(row.code.split('-')[1]);
        const hierarchy = row.value;

        const company = result.find((x) => x.company_id == idCompany);
        if (!company) {
            result.push({
                company_id: idCompany,
                admin_id: admin_id,
                admin_id_assing: admin_id_assing,
                roles: [{
                    role_id: idRole,
                    hierarchy: hierarchy
                }]
            });
            continue;
        }

        company.roles.push({ role_id: idRole, hierarchy: hierarchy });
    }

    return result;
}

export const formatAdministratorExportDto = (administrators: Administrator[]): AdministratorExportDto[] => {
    return administrators.map((x) => {
        const row: AdministratorExportDto = {
            first_name: x.first_name,
            last_name: x.last_name,
            type_identification: getIdentification(x.identification?.type).label,
            identification: x.identification?.identification,
            user_name: x.user_name ?? '',            
            ceo_label: x.is_ceo ? 'Si' : 'No',
            active: x.is_active ? 'Activo' : 'Inactivo',
            email: (x.contact && x.contact?.length > 0) ? x.contact[0].identification : '',
            cellphone: (x.contact && x.contact?.length > 1) ? x.contact[1].identification : '',
            birth_date: x.birth_date?.toString() ?? '',
            detail: x.detail ?? ''
        }

        return row;
    });
}